import {LegendItem} from '@hconnect/common/components/runningTimes/LegendItem'
import {Box} from '@mui/material'
import {RUNNING_TIME_COLOR} from '@widgets/common-running-times'
import {useTranslation} from 'react-i18next'

import {RUNNING_TIMES_WIDGET_NAMESPACE} from '../consts'

export const OperatingHoursLegendList = () => {
  const {t} = useTranslation(RUNNING_TIMES_WIDGET_NAMESPACE)

  return (
    <Box sx={{display: 'flex', gap: 1, mb: 2, justifyContent: 'flex-end', flexFlow: 'wrap'}}>
      <LegendItem color={RUNNING_TIME_COLOR.running} label={t('runningTime.legend.running')} />
      <LegendItem
        color={RUNNING_TIME_COLOR.stoppedUndefined}
        label={t('runningTime.legend.undefinedStoppage')}
      />
      <LegendItem
        color={RUNNING_TIME_COLOR.stoppedDefined}
        label={t('runningTime.legend.unplannedStoppage')}
      />
      <LegendItem
        color={RUNNING_TIME_COLOR.planned}
        label={t('runningTime.legend.plannedStoppage')}
      />
    </Box>
  )
}
